module.exports = __webpack_public_path__ + "static/img/06022D_2_3_R_20200306_fit.a0cd8ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/06022D_2_3_R_20200306_fit.png
// module id = su5t
// module chunks = 0